
import UserSubscribeModal from "./modal/UserSubscribeModal.vue";
import {SubscribeKey} from "modules/subscribe/share-app/api/entity/SubscribeKey";

export default {
    components: { UserSubscribeModal },
    methods: {
        onClose() {
            this.open = false;
        },
        async subscribe(moduleName: string, entityName: string, action: string, meta: { entityId: string; entityName: string }) {
            this.key = new SubscribeKey(moduleName, entityName, meta.entityId, action);
            this.orgName = meta.entityName;
            this.open = true;
        }
    },
    async mounted() {
        (window as any).subscribe = this.subscribe;
    },
    data() {
        return {
            open: false,
            key: null,
            orgName: null,
        }
    }
}
